export default __webpack_public_path__ + "static/media/video_app.3a1153a1.mp4";